import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import moment from 'moment';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';

class TulajdonsagContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,

      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'LOAD',
      // ['FEL', 'MOD']
      formType: 'FEL',
      
      // FORM VALUES
      formAzonosito: '',
      formLeiras: '',
      formMegjelenes: '',   
      formLeirasAngol: '',


      // TABLE VALUES 
      baseJson: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,

      // MODAL UTILS
      modalForm: false,
      modalView: false,
      modalDelete: false,
      formButtonLoading: false,
      deleteButtonLoading: false,
      isTable: true,
    };
  }

  componentDidMount() {
    this.listTulajdonsag();
    this.checkAngolNyelv();
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  checkAngolNyelv = () => {
    Services.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  handleTableLayoutChange = () => {
    this.setState(prevState => ({ isTable: !prevState.isTable }));
  }

  listTulajdonsag = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listTulajdonsag((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formAzonosito: '',
      formLeiras: '',
      formMegjelenes: '',
      formLeirasAngol: '',
      currentId: null
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formType: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
      formAzonosito: '',
      formLeiras: '',
      formMegjelenes: '',
      formLeirasAngol: '',
    }, () => {
      this.getTulajdonsagForm(id);
      this.toggleFormModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  saveTulajdonsag = (e, submitFormObj) => {
    const {
      formType,
      currentId,
    } = this.state;
    const {
      formAzonosito,
      formLeiras,
      formMegjelenes,
      formLeirasAngol,
    } = submitFormObj;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formType === 'FEL') {
        let submitObj = {
          azonosito: formAzonosito,
          leiras: formLeiras,
          megjelenes: formMegjelenes,
        };

        if (this.state.angolNyelv == true)
          submitObj.leirasangol = formLeirasAngol;
  
        Services.addTulajdonsag(submitObj, (err) => {
          if (!err) {
            this.toggleFormModal();
            this.listTulajdonsag();
            this.props.globals.addSuccess('Tulajdonság felvéve!');
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
  
      if (formType === 'MOD') {
        let submitObj = {
          azonosito: formAzonosito,
          leiras: formLeiras,
          megjelenes: formMegjelenes,
          id: currentId,
        };

        if (this.state.angolNyelv == true)
          submitObj.leirasangol = formLeirasAngol;

        Services.editTulajdonsag(submitObj, (err) => {
          if (!err) {
            this.toggleFormModal();
            this.listTulajdonsag();
            this.props.globals.addSuccess('Tulajdonság módosítva!');
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  getTulajdonsagView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.getTulajdonsag(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW',
          });
        }
      });
    });
  }

  getTulajdonsagForm = (id) => {
    this.setState({
      formStatus: 'LOAD', 
    }, () => {
      Services.getTulajdonsag(id, (err, res) => {
        if (!err) {
          this.setState({
            formAzonosito: res[0].azonosito,
            formLeiras: res[0].leiras,
            formMegjelenes: res[0].megjelenes,
            formLeirasAngol: res[0].leirasangol,
            formStatus: 'DATA', 
          });
        } else {
          this.setState({
            formStatus: 'NETW',
          });
        }
      });
    });
  }

  deleteTulajdonsag = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteTulajdonsag(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listTulajdonsag();
        this.props.globals.addSuccess('Tulajdonság törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }
  
  handleViewClick = (id) => {
    this.setState({
      currentId: id,
    }, () => {
      this.getTulajdonsagView(id, false);
      this.toggleViewModal();
    });
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        <React.Fragment>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment>
        {this.hasRole(['MUSOR_TULAJDONSAG'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Tulajdonság:</h6>
        <b>Azonosító: </b>
         {viewObj && viewObj.azonosito}
        <br />
        <b>Leírás: </b>
          {viewObj && viewObj.leiras}
        <br />
        {this.state.angolNyelv == true && (
          <div>
            <b>Leírás (angol): </b>
              {viewObj && viewObj.leirasangol}
            <br />
          </div>
        )}
        <b>Megjelenés: </b>
          {viewObj && viewObj.megjelenes}
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'leiras',
        text: 'Leírás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'megjelenes',
        text: 'Megjelenés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderTableView = () => {
    return (
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => { this.listTulajdonsag(); }}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderForm = () => {
    const {
      formType,
      currentId,
      formAzonosito,
      formLeiras,
      formMegjelenes,
      formLeirasAngol,
    } = this.state;

    return (
      <React.Fragment>
        <RFField
          label="Azonosító: *"
          name="formAzonosito"
          disabled={formType === 'MOD'}
          required
          maxLength="50"
          value={formAzonosito}
          onChange={this.handleInputChange}
        />
        <RFField
          label="Leírás:"
          name="formLeiras"
          maxLength="250"
          value={formLeiras}
          onChange={this.handleInputChange}
        />
        {this.state.angolNyelv == true && (
            <RFField
              label={'Leírás (angol): '}
              name="formLeirasAngol"
              id="formTitulusAngol"
              maxLength="250"
              value={formLeirasAngol}
              onChange={this.handleInputChange}
            />
        )}
          <RFField
            label={'Megjelenés: *'}
            name="formMegjelenes"
            id="formMegjelenes"
            required
            maxLength="50"
            value={formMegjelenes}
            onChange={this.handleInputChange}
          />
      </React.Fragment>
    );
  }

  renderModals = () => {
    return (
      <React.Fragment>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveTulajdonsag}
            title={this.state.currentId ? 'Tulajdonság módosítása': 'Tulajdonság rögzítése'}
            footer={
              <React.Fragment>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  //onClick={() => this.deleteTulajdonsag()}
                  loading={this.state.formButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getTulajdonsag(this.state.currentId)}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
        
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              type="button"
              onClick={() => this.deleteTulajdonsag()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
        <ModalHeader>
          {'Megtekintés'}
        </ModalHeader>
        <ModalBody>
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {}}
            />),
            DATA: (this.renderView())
          }[this.state.viewStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.hasRole(['MUSOR_TULAJDONSAG'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új tulajdonság'}
              </Button>
            )}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

TulajdonsagContent.propTypes = {
  globals: PropTypes.object
};

export default TulajdonsagContent;